import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import style from "../Assets/css/PlacementForm.css";
import { BASE_URL } from "../env";
import { store } from "react-notifications-component";

const PlacementForm = () => {
	const [email, setEmail] = useState("");
	const [name, setName] = useState("");
	const [phone, setPhone] = useState("");
	const [collegeName, setCollegename] = useState("");
	const [fin_yr_stu, setFin_yr_stu] = useState("");
	const [comp_visited, setComp_visited] = useState("");
	const [annual_clg_fee, setAnnual_clg_fee] = useState("");
	const [higherStudy_stu, setHigherStudy_stu] = useState("");

	const [chairman_name, setChairman_name] = useState("");
	const [chairman_phone, setChairman_phone] = useState("");
	const [hod_it_name, setHod_it_name] = useState("");
	const [hod_it_phone, setHod_it_phone] = useState("");
	const [hod_cse_name, setHod_cse_name] = useState("");
	const [hod_cse_phone, setHod_cse_phone] = useState("");
	const [hod_ece_name, setHod_ece_name] = useState("");
	const [hod_ece_phone, setHod_ece_phone] = useState("");
	const [pl_ofcr, setPl_ofcr] = useState("");
	const [pl_ofcr_phone, setPl_ofcr_phone] = useState("");
	const [stu_act_coordinator, setStu_act_coordinator] = useState("");
	const [stu_act_coordinator_phone, setStu_act_coordinator_phone] =
		useState("");

	const [od1, setOd1] = useState("");
	const [od2, setOd2] = useState("");
	const [od3, setOd3] = useState("");
	const [od4, setOd4] = useState("");

	function SubmitHandler() {
		// if (email == "" || phone == "")
		// {
		//   return;
		// }
		// ReactPixel.init("337209321107283", advancedMatching, options);
		// ReactPixel.trackCustom("TCSfreesuccess");

		const notifyPopup = () => {
			store.addNotification({
				title: "Success!",
				message: "Form Submitted Successfully!",
				type: "success",
				background: "pink",
				insert: "bottom",
				container: "bottom-right",
				animationIn: ["animate__animated", "animate__fadeIn"],
				animationOut: ["animate__animated", "animate__fadeOut"],
				dismiss: {
					duration: 3000,
					onScreen: true,
				},
			});
		};
		fetch(BASE_URL + "/placementForm", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: localStorage.getItem("token"),
			},

			body: JSON.stringify({
				studentName: name,
				mobileNumber: phone,
				emailId: email,
				collegeName: collegeName,
				finalYearTotal: fin_yr_stu,
				placementCompanies: comp_visited,
				collegeFees: annual_clg_fee,
				higherStudiesPerc: higherStudy_stu,

				chairmanName: chairman_name,
				chairmanContactNo: chairman_phone,
				HODNameIT: hod_it_name,
				HODContactNoIT: hod_it_phone,
				HODNameCSE: hod_cse_name,
				HODContactNoCSE: hod_cse_phone,
				HODNameECE: hod_ece_name,
				HODContactNoECE: hod_ece_phone,
				placementOfficerName: pl_ofcr,
				placementOfficerNo: pl_ofcr_phone,
				SACCName: stu_act_coordinator,
				SACCNo: stu_act_coordinator_phone,

				CRTStatus: od1,
				CRTTraining: od2,
				CRTDetails: od3,
				CRTComments: od4,
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				console.log(response);
				console.log("Placement success");
				notifyPopup();
				setAnnual_clg_fee("");
				setChairman_name("");
				setChairman_phone("");
				setCollegename("");
				setComp_visited("");
				setEmail("");
				setFin_yr_stu("");
				setHigherStudy_stu("");
				setHod_cse_name("");
				setHod_cse_phone("");
				setHod_ece_name("");
				setName("");
				setPhone("");
				setHod_it_name("");
				setHod_it_phone("");
				setHod_ece_phone("");
				setPl_ofcr("");
				setPl_ofcr_phone("");
				setStu_act_coordinator("");
				setStu_act_coordinator_phone("");
				setOd1("");
				setOd2("");
				setOd3("");
				setOd4("");
			})
			.catch((err) => {
				console.log("Placement error : \n" + err);
			});
	}

	return (
		<div style={{ overflowX: "hidden" }}>
			<Navbar />
			<>
				<div
					className="text-center"
					style={{ marginTop: "60px", fontSize: "409px" }}
				>
					<h1>Placement Form </h1>
				</div>

				<div
					className={" row my-2 py-5 " + style.verticleCenter}

					//   style={{display:"flex",justifyContent:"center"}}
				>
					<div className="col-sm-12 col-lg-6 col-md-6 col-xl-6 mx-auto">
						<h4>Student Details</h4>
						<div className="container card">
							<label for="name">Full Name</label>
							<br />
							<input
								className={style.newinput}
								id="name"
								type="text"
								placeholder="Full Name"
								value={name}
								onChange={(e) => setName(e.target.value)}
							/>
							<br />

							<label for="phone">
								Phone No. (without country code)
							</label>
							<br />
							<input
								id="phone"
								className={style.newinput}
								type="tel"
								placeholder="Phone No."
								value={phone}
								onChange={(e) => setPhone(e.target.value)}
							/>
							<br />

							<label for="email">Email</label>
							<br />
							<input
								className={style.newinput}
								type="email"
								id="email"
								placeholder="E-mail"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
							/>
							<br />

							<label for="collegeName">College Name</label>
							<br />
							<input
								className={style.newinput}
								type="text"
								id="collegeName"
								placeholder="College Name"
								value={collegeName}
								onChange={(e) => setCollegename(e.target.value)}
							/>
							<br />

							<label for="fin_yr_stu">
								Total students in Final year
							</label>
							<br />
							<input
								className={style.newinput}
								type="text"
								id="fin_yr_stu"
								placeholder="Total students in Final year"
								value={fin_yr_stu}
								onChange={(e) => setFin_yr_stu(e.target.value)}
							/>
							<br />

							<label for="comp_visited">
								Company visited for placements
							</label>
							<br />
							<input
								className={style.newinput}
								type="text"
								id="comp_visited"
								placeholder="Company visited for placements"
								value={comp_visited}
								onChange={(e) =>
									setComp_visited(e.target.value)
								}
							/>
							<br />

							<label for="annual_clg_fee">
								Annual fees of college
							</label>
							<br />
							<input
								className={style.newinput}
								type="text"
								id="annual_clg_fee"
								placeholder="Annual fees of college"
								value={annual_clg_fee}
								onChange={(e) =>
									setAnnual_clg_fee(e.target.value)
								}
							/>
							<br />

							<label for="higherStudy_stu">
								What percentage of students opt for higher
								studies?
							</label>
							<br />
							<input
								className={style.newinput}
								type="text"
								id="higherStudy_stu"
								placeholder="What percentage of students opt for higher studies?"
								value={higherStudy_stu}
								onChange={(e) =>
									setHigherStudy_stu(e.target.value)
								}
							/>
							<br />
						</div>
						<div>
							<h4>Other Details</h4>
							<div className="container card">
								<label for="od1">
									Is your college providing CRT(Campus
									Recruitment Training)? (Yes/No)
								</label>
								<br />
								<input
									className={style.newinput}
									id="od1"
									type="text"
									placeholder="Is your college providing CRT?"
									value={od1}
									onChange={(e) => setOd1(e.target.value)}
								/>
								<br />

								<label for="od2">
									Who is paying for CRT Training? (Student,
									Management, Other, No CRT)
								</label>
								<br />
								<input
									id="od2"
									className={style.newinput}
									type="text"
									placeholder="Who is paying for CRT Training?"
									value={od2}
									onChange={(e) => setOd2(e.target.value)}
								/>
								<br />

								<label for="od3">
									Could you provide more details of the CRT
									(if not applicable -please write NA)
								</label>
								<br />
								<input
									className={style.newinput}
									type="text"
									id="od3"
									placeholder="Could you provide more details of the CRT."
									value={od3}
									onChange={(e) => setOd3(e.target.value)}
								/>
								<br />

								<label for="od4">
									Additional comments regarding CRT (if not
									applicable- please write NA)
								</label>
								<br />
								<input
									className={style.newinput}
									type="text"
									id="od4"
									placeholder="Additional comments regarding CRT..."
									value={od4}
									onChange={(e) => setOd4(e.target.value)}
								/>
								<br />
							</div>
						</div>{" "}
					</div>
					{/* </div>

              <div
              className={
                "container-fluid row my-5 py-5 " + style.verticleCenter
              }
              style={{ left: "50%", overflow: "hidden" }}
            > */}
					<div className="col-sm-12 col-lg-6 col-md-6 col-xl-6 mx-auto">
						<h4>Head Details</h4>
						<div className="container card">
							<label for="chairman_name">
								Full Name of Chairman/Director
							</label>
							<br />
							<input
								className={style.newinput}
								id="chairman_name"
								type="text"
								placeholder="Full Name of Chairman/Director"
								value={chairman_name}
								onChange={(e) =>
									setChairman_name(e.target.value)
								}
							/>
							<br />

							<label for="chairman_phone">
								Phone No. (without country code)
							</label>
							<br />
							<input
								id="chairman_phone"
								className={style.newinput}
								type="tel"
								placeholder="phone of chairman"
								value={chairman_phone}
								onChange={(e) =>
									setChairman_phone(e.target.value)
								}
							/>
							<br />

							<label for="hod_it_name">Full Name of IT HOD</label>
							<br />
							<input
								className={style.newinput}
								id="hod_it_name"
								type="text"
								placeholder="Full Name of HOD of IT"
								value={hod_it_name}
								onChange={(e) => setHod_it_name(e.target.value)}
							/>
							<br />

							<label for="hod_it_phone">
								Phone No. (without country code)
							</label>
							<br />
							<input
								id="hod_it_phone"
								className={style.newinput}
								type="tel"
								placeholder="Contact no of HOD of IT"
								value={hod_it_phone}
								onChange={(e) =>
									setHod_it_phone(e.target.value)
								}
							/>
							<br />

							<label for="hod_cse_name">Full Name CSE HOD</label>
							<br />
							<input
								className={style.newinput}
								id="hod_cse_name"
								type="text"
								placeholder="Full Name of HOD of CSE"
								value={hod_cse_name}
								onChange={(e) =>
									setHod_cse_name(e.target.value)
								}
							/>
							<br />

							<label for="hod_cse_phone">
								Phone No. (without country code)
							</label>
							<br />
							<input
								id="hod_cse_phone"
								className={style.newinput}
								type="tel"
								placeholder="Contact no of HOD of CSE"
								value={hod_cse_phone}
								onChange={(e) =>
									setHod_cse_phone(e.target.value)
								}
							/>
							<br />

							<label for="hod_ece_name">
								Full Name of ECE HOD
							</label>
							<br />
							<input
								className={style.newinput}
								id="hod_ece_name"
								type="text"
								placeholder="Full Name of HOD of ECE"
								value={hod_ece_name}
								onChange={(e) =>
									setHod_ece_name(e.target.value)
								}
							/>
							<br />

							<label for="hod_ece_phone">
								Phone No. (without country code)
							</label>
							<br />
							<input
								id="hod_ece_phone"
								className={style.newinput}
								type="tel"
								placeholder="Contact no of HOD of ECE"
								value={hod_ece_phone}
								onChange={(e) =>
									setHod_ece_phone(e.target.value)
								}
							/>
							<br />

							<label for="pl_ofcr">
								Full Name Of Placement Officer{" "}
							</label>
							<br />
							<input
								className={style.newinput}
								type="text"
								id="pl_ofcr"
								placeholder="Full Name Of Placement Officer "
								value={pl_ofcr}
								onChange={(e) => setPl_ofcr(e.target.value)}
							/>
							<br />

							<label for="pl_ofcr_phone">
								Contact No Of Placement Officer{" "}
							</label>
							<br />
							<input
								className={style.newinput}
								type="tel"
								id="pl_ofcr_phone"
								placeholder="Contact No Of Placement Officer "
								value={pl_ofcr_phone}
								onChange={(e) =>
									setPl_ofcr_phone(e.target.value)
								}
							/>
							<br />

							<label for="stu_act_coordinator">
								Student Activity Center Coordinator Full Name{" "}
							</label>
							<br />
							<input
								className={style.newinput}
								type="text"
								id="stu_act_coordinator"
								placeholder="Student Activity Center Coordinator Full Name"
								value={stu_act_coordinator}
								onChange={(e) =>
									setStu_act_coordinator(e.target.value)
								}
							/>
							<br />

							<label for="stu_act_coordinator_phone">
								Student Activity Center Coordinator Contact No
							</label>
							<br />
							<input
								className={style.newinput}
								type="tel"
								id="stu_act_coordinator_phone"
								placeholder="Student Activity Center Coordinator Contact No"
								value={stu_act_coordinator_phone}
								onChange={(e) =>
									setStu_act_coordinator_phone(e.target.value)
								}
							/>
							<br />
						</div>
					</div>
					{/* </div>


              <div
              className={
                "container-fluid row my-5 py-5 " + style.verticleCenter
              }
              style={{ left: "50%", overflow: "hidden" }}
            > */}

					<button
						onClick={() => {
							SubmitHandler();
						}}
						className="btn btn-primary"
						style={{ width: "50%", margin: "0 auto" }}
					>
						Done
					</button>
				</div>
			</>
			<Footer />
		</div>
	);
};

export default PlacementForm;
